"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6917],{

/***/ 56917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ NltOffers_Offer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/icons/car.tsx


const CarIcon = () => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "#656B72",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M2.792 12.667c.345 0 .625-.28.625-.625v-.625h9.166v.625c0 .345.28.625.625.625h.417c.345 0 .625-.28.625-.625V8.5c0-.458-.131-.881-.347-1.25h.295c.143 0 .268-.097.303-.236l.156-.625c.05-.198-.1-.389-.303-.389h-1.36l-.816-2.028c-.318-.789-1.083-1.305-1.933-1.305h-4.49c-.85 0-1.616.516-1.933 1.305L3.005 6H1.646c-.203 0-.353.191-.303.388l.156.625c.033.13.169.237.303.237h.295c-.216.369-.347.792-.347 1.25v3.542c0 .345.28.625.625.625h.417zM11.647 6H4.353l.629-1.561c.127-.317.43-.522.773-.522h4.49c.342 0 .646.205.773.522l.629 1.56zm.936 4.167H3.417c-.23 0-.417-.187-.417-.417V8.5c0-.69.56-1.25 1.25-1.25h7.5c.69 0 1.25.56 1.25 1.25v1.25c0 .23-.187.417-.417.417zM5.917 9.12c0-.498-.75-1.246-1.25-1.246s-.834.332-.834.83c0 .5.334.832.834.832.5 0 1.25.083 1.25-.416zm5.416.416c.5 0 .834-.333.834-.831 0-.499-.334-.831-.834-.831-.5 0-1.25.748-1.25 1.246 0 .499.75.416 1.25.416z",
        transform: "translate(-413 -1162) translate(45 818) translate(344 75) translate(24 269)"
      })
    })
  })
});

/* harmony default export */ var car = (CarIcon);
;// CONCATENATED MODULE: ./src/icons/calendar.tsx


const CalendarIcon = () => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "#656B72",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M6.02 8.833H4.98c-.173 0-.313-.14-.313-.312V7.479c0-.172.14-.312.312-.312h1.042c.172 0 .312.14.312.312v1.042c0 .172-.14.312-.312.312zm2.813-.312V7.479c0-.172-.14-.312-.312-.312H7.479c-.172 0-.312.14-.312.312v1.042c0 .172.14.312.312.312h1.042c.172 0 .312-.14.312-.312zm2.5 0V7.479c0-.172-.14-.312-.312-.312H9.979c-.172 0-.312.14-.312.312v1.042c0 .172.14.312.312.312h1.042c.172 0 .312-.14.312-.312zm-2.5 2.5V9.979c0-.172-.14-.312-.312-.312H7.479c-.172 0-.312.14-.312.312v1.042c0 .172.14.312.312.312h1.042c.172 0 .312-.14.312-.312zm-2.5 0V9.979c0-.172-.14-.312-.312-.312H4.979c-.172 0-.312.14-.312.312v1.042c0 .172.14.312.312.312h1.042c.172 0 .312-.14.312-.312zm5 0V9.979c0-.172-.14-.312-.312-.312H9.979c-.172 0-.312.14-.312.312v1.042c0 .172.14.312.312.312h1.042c.172 0 .312-.14.312-.312zm2.5-6.771v9.167c0 .69-.56 1.25-1.25 1.25H3.417c-.69 0-1.25-.56-1.25-1.25V4.25c0-.69.56-1.25 1.25-1.25h1.25V1.646c0-.172.14-.313.312-.313h1.042c.172 0 .312.141.312.313V3h3.334V1.646c0-.172.14-.313.312-.313h1.042c.172 0 .312.141.312.313V3h1.25c.69 0 1.25.56 1.25 1.25zm-1.25 9.01V5.5H3.417v7.76c0 .086.07.157.156.157h8.854c.086 0 .156-.07.156-.157z",
        transform: "translate(-413 -1182) translate(45 818) translate(344 75) translate(24 289)"
      })
    })
  })
});

/* harmony default export */ var calendar = (CalendarIcon);
// EXTERNAL MODULE: ./src/themes/index.tsx + 3 modules
var themes = __webpack_require__(75159);
// EXTERNAL MODULE: ./src/uikit/Badges/LimitedOffer.tsx + 1 modules
var LimitedOffer = __webpack_require__(94999);
// EXTERNAL MODULE: ./src/uikit/Badges/Info.tsx
var Info = __webpack_require__(75600);
// EXTERNAL MODULE: ./src/uikit/Titles/OfferCard.tsx
var OfferCard = __webpack_require__(66018);
// EXTERNAL MODULE: ./src/uikit/Boxes/Price.tsx
var Price = __webpack_require__(64673);
// EXTERNAL MODULE: ./src/uikit/Badges/WithIcon.tsx
var WithIcon = __webpack_require__(93531);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./src/utils/gtm/events.ts + 1 modules
var events = __webpack_require__(99778);
// EXTERNAL MODULE: ./src/utils/gtm/mappers.ts + 2 modules
var mappers = __webpack_require__(29590);
// EXTERNAL MODULE: ./src/utils/gtm/constants.ts
var constants = __webpack_require__(98845);
// EXTERNAL MODULE: ./src/utils/imageAlt.ts
var utils_imageAlt = __webpack_require__(61254);
;// CONCATENATED MODULE: ./src/components/NltOffers/Offer.tsx













const Offer = _ref => {
  let {
    item,
    index,
    listId = 'nlt_listing',
    listName = 'Offerte noleggio a lungo termine'
  } = _ref;
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  const router = (0,next_router.useRouter)();
  const title = `${item.brand} ${item.model}`;
  const altTitle = `Noleggio a Lungo Termine ${item.brand} ${item.model}`;
  const imageAlt = (0,utils_imageAlt/* getOfferCardAlt */.Pr)(item, 'noleggio a lungo termine');
  const subtitle = item.version;
  const imageSrc = item.image;
  const href = ['/noleggio-a-lungo-termine/', item.brandCode, '/', item.modelCode, '/', item.code, '?deposit=', item.deposit, '&contractLength=', item.contractLength, '&annualMileage=', item.annualMileage].join('');
  const durationTitle = t('nltOffersComponent:durationTitle');
  const durationValue = t('nltOffersComponent:durationValue', {
    value: item.contractLength
  });
  const distanceTitle = t('nltOffersComponent:distanceTitle');
  const distanceValue = t('nltOffersComponent:distanceValue', {
    value: item.annualMileage == 0 ? 'illimitati' : item.annualMileage.toLocaleString('it-IT')
  });
  const depositTitle = t('nltOffersComponent:depositTitle');
  const depositValue = item.deposit === 0 ? t('nltOffersComponent:depositValue0', {
    value: item.deposit
  }) : t('nltOffersComponent:depositValue', {
    value: item.deposit.toLocaleString('it-IT')
  });
  const priceDescription = t('nltOffersComponent:priceDescription');
  const priceValue = t('nltOffersComponent:priceValue', {
    value: item.monthlyRate.toLocaleString('it-IT')
  });
  let limitedOfferBadge = null;

  if (item.expirationDate) {
    const offerTimeStamp = Date.parse(item.expirationDate);
    const nowTimeStamp = new Date().getTime();
    const diffTimeStamp = offerTimeStamp - nowTimeStamp;

    if (diffTimeStamp > 0) {
      limitedOfferBadge = t('nltOffersComponent:limitedOfferBadge', {
        value: Math.floor(diffTimeStamp / (24 * 60 * 60 * 1000))
      });
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
    title: altTitle,
    borderRadius: 10,
    bg: "baseWhite",
    pb: "l",
    overflow: "hidden",
    pos: "relative",
    borderColor: themes/* theme.colors.borders.grey */.r.colors.borders.grey,
    borderWidth: 1,
    boxShadow: themes/* theme.shadows.cards */.r.shadows.cards,
    _hover: {
      cursor: 'pointer',
      textDecoration: 'none',
      boxShadow: '0 4px 12px 0px rgba(65, 164, 118, 0.22)'
    },
    onClick: () => {
      (0,events/* pushSelectItem */.Yy)({
        item: (0,mappers/* rentOfferToProductItem */.ck)(item, {
          index
        }),
        listId,
        listName,
        click: {
          link_text: title,
          link_url: href,
          link_type: constants/* CTA_PRODUCT_PAGE */.Ot
        }
      });
      router.push(href);
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
      h: "12.5rem",
      mb: "xs",
      pos: "relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: imageSrc,
        alt: imageAlt,
        layout: "fill",
        objectFit: "contain",
        loading: "lazy"
      }), limitedOfferBadge && /*#__PURE__*/(0,jsx_runtime.jsx)(LimitedOffer/* default */.Z, {
        position: "absolute",
        top: "1rem",
        left: "1rem",
        children: limitedOfferBadge
      }), item.mainTag && /*#__PURE__*/(0,jsx_runtime.jsx)(Info/* default */.Z, {
        position: "absolute",
        bottom: ".625rem",
        left: "1rem",
        children: item.mainTag
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
        position: "absolute",
        bottom: "0rem"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
      textAlign: "left",
      h: "8.5rem",
      pos: "relative",
      px: "m",
      position: "static",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: href,
        style: {
          color: themes/* theme.colors.baseDark */.r.colors.baseDark
        },
        title: altTitle,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(OfferCard/* default */.Z, {
          title: title,
          subtitle: subtitle
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        marginLeft: "l",
        position: "static",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Price/* default */.Z, {
          value: priceValue,
          description: priceDescription,
          textAlign: "right",
          position: "absolute",
          top: "16.2rem",
          right: "1rem"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(WithIcon/* default */.Z, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(car, {}),
          name: distanceTitle,
          value: distanceValue
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(WithIcon/* default */.Z, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(calendar, {}),
          name: durationTitle,
          value: durationValue
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(WithIcon/* default */.Z, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(car, {}),
          name: depositTitle,
          value: depositValue
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
          color: "baseDark",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "0.75rem",
          letterSpacing: "0.4px",
          marginTop: "xs",
          h: "16px",
          children: item.variations > 0 ? t('nltOffersComponent:variations', {
            count: item.variations
          }) : null
        })]
      })]
    })]
  });
};

/* harmony default export */ var NltOffers_Offer = (Offer);

/***/ }),

/***/ 75600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const Info = _ref => {
  let {
    children
  } = _ref,
      others = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Badge */ .Ct, _objectSpread(_objectSpread({
    bg: "baseNeutral.700",
    fontFamily: "Montserrat-SemiBold",
    fontSize: "0.625rem",
    color: "baseWhite",
    lineHeight: "15px",
    letterSpacing: ".33px",
    rounded: "15px",
    paddingY: ".3rem",
    paddingX: ".5rem"
  }, others), {}, {
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Info);

/***/ }),

/***/ 94999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Badges_LimitedOffer; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/icons/clock.tsx


const ClockIcon = () => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "#262626",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12.272 12.673c.228-.214.228-.56 0-.773l-1.033-.968c.753-.875 1.203-1.99 1.203-3.201.002-.761-.175-1.483-.491-2.13.542-.468.882-1.137.882-1.883 0-1.41-1.217-2.551-2.722-2.551-1.1 0-2.049.61-2.477 1.492-.42-.046-.848-.046-1.268 0-.428-.882-1.376-1.492-2.477-1.492-1.505 0-2.722 1.141-2.722 2.551 0 .746.34 1.415.882 1.882-.316.648-.493 1.37-.493 2.129 0 1.212.452 2.326 1.203 3.2l-1.033.969c-.229.214-.229.56 0 .772.228.215.598.215.824 0l1.033-.968c1.98 1.497 4.83 1.513 6.83 0l1.035.97c.228.215.598.215.824 0zm-.946-8.045c-.636-.78-1.507-1.381-2.51-1.714.277-.394.753-.654 1.295-.654.858 0 1.556.654 1.556 1.458 0 .345-.13.661-.34.91zm-8.65 0c-.214-.249-.343-.565-.343-.91 0-.804.698-1.458 1.556-1.458.542 0 1.018.26 1.298.654-1.006.333-1.877.934-2.511 1.714zM7 11.738c-2.365 0-4.278-1.793-4.278-4.01 0-2.21 1.906-4.01 4.278-4.01 2.367 0 4.278 1.796 4.278 4.01 0 2.217-1.913 4.01-4.278 4.01zm1.531-2.25l.44-.602c.09-.125.059-.294-.075-.38L7.68 7.721V5.268c0-.15-.132-.274-.292-.274H6.61c-.16 0-.292.123-.292.274V8.25c0 .091.047.176.127.226l1.677 1.082c.134.084.316.052.408-.07z",
        transform: "translate(-413 -1472) translate(45 1377) translate(344 75) translate(16 16) translate(8 4)"
      })
    })
  })
});

/* harmony default export */ var clock = (ClockIcon);
;// CONCATENATED MODULE: ./src/uikit/Badges/LimitedOffer.tsx


const _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







const LimitedOfferStyle = /*#__PURE__*/(0,styled_components_browser_esm["default"])(index_esm/* Box */.xu).withConfig({
  componentId: "sc-1kch8fu-0"
})(["& svg{display:inline;margin-right:4px;vertical-align:sub;}"]);

const LimitedOffer = _ref => {
  let {
    children
  } = _ref,
      others = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LimitedOfferStyle, _objectSpread(_objectSpread({}, others), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Badge */.Ct, {
      bg: "feedbackWarning",
      color: "baseDark",
      fontFamily: "Montserrat-SemiBold",
      fontSize: "0.625rem",
      lineHeight: "15.6px",
      letterSpacing: ".33px",
      rounded: "15px",
      paddingY: ".3rem",
      paddingX: ".5rem",
      textTransform: "initial",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(clock, {}), children]
    })
  }));
};

/* harmony default export */ var Badges_LimitedOffer = (LimitedOffer);

/***/ }),

/***/ 93531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53918);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


const _excluded = ["icon", "name", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const WithIconStyle = /*#__PURE__*/(0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu).withConfig({
  componentId: "sc-9r4ze0-0"
})(["font-family:Montserrat-Medium,sans-serif;font-size:0.75rem;line-height:15.6px;letter-spacing:0.4px;margin-top:0.25rem;color:", ";& svg{display:inline;vertical-align:bottom;}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.palette.baseNeutral700;
});

const WithIcon = _ref2 => {
  let {
    icon,
    name,
    value
  } = _ref2,
      other = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref2, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WithIconStyle, _objectSpread(_objectSpread({}, other), {}, {
    children: [icon, " ", name, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
      children: value
    })]
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (WithIcon);

/***/ }),

/***/ 64673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53918);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48641);
/* harmony import */ var src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2732);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["value", "description"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







const BoxDescription = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  componentId: "sc-zru8zp-0"
})(["display:block;margin-top:0;", ""], src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_4__/* .TextStyles.infoXxsN700MediumDx */ .k.infoXxsN700MediumDx);

const PriceBox = _ref => {
  let {
    value,
    description
  } = _ref,
      others = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, _objectSpread(_objectSpread({
    color: "baseDark",
    fontFamily: "Montserrat-SemiBold",
    fontSize: "1.5rem",
    lineHeight: "31.2px",
    letterSpacing: "0.86px"
  }, others), {}, {
    children: [value, description && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(BoxDescription, {
      children: description
    })]
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (PriceBox);

/***/ }),

/***/ 66018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






const OfferCard = _ref => {
  let {
    title,
    subtitle,
    href
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
      color: "baseDark",
      fontFamily: "Montserrat-SemiBold",
      fontSize: "1rem",
      lineHeight: "21px",
      letterSpacing: "0.2px",
      children: href ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
        href: href,
        children: title
      }) : title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
      color: "baseNeutral.700",
      fontFamily: "Montserrat-Regular",
      fontSize: "0.875rem",
      textTransform: "capitalize",
      lineHeight: "18px",
      letterSpacing: "0.2px",
      marginTop: "0rem!important",
      mb: "xs",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      children: href ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
        href: href,
        children: subtitle
      }) : subtitle
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .iz, {})]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (OfferCard);

/***/ }),

/***/ 61254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CY": function() { return /* binding */ getGalleryImagesAlt; },
/* harmony export */   "KX": function() { return /* binding */ getSellVehicleAltData; },
/* harmony export */   "NB": function() { return /* binding */ UNKNOWN_MAIN_VIEW; },
/* harmony export */   "Pr": function() { return /* binding */ getOfferCardAlt; },
/* harmony export */   "fU": function() { return /* binding */ getBrandLogoAlt; },
/* harmony export */   "k8": function() { return /* binding */ getVehicleImageAlt; }
/* harmony export */ });
/* unused harmony exports MAIN_IMAGE_VIEW, UNKNOWN_VIEW, getVehicleAltBase, getVehicleImageView */
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _dateUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73119);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/**
 * Attributo ALT delle immagini dei veicoli.
 *
 * Template richiesto per la foto principale di ogni offerta:
 *   {Brand} {Modello} {Versione} {Anno} – vista laterale sinistra
 *
 * Il template si applica quando lo scatto e' davvero una laterale sinistra.
 * Quando non lo e', l'alt dichiara l'angolazione reale ricavata dall'alt che
 * arriva da offers-explorer: descrivere un'inquadratura diversa da quella
 * mostrata vale meno di un alt generico, sia per chi usa uno screen reader sia
 * per la SEO. Sulle offerte di noleggio, ad esempio, la prima foto e' quasi
 * sempre un frontale e non una laterale sinistra.
 */

const MAIN_IMAGE_VIEW = 'vista laterale sinistra';
/** Prima foto con angolazione non ricavabile: e' comunque un esterno dell'auto. */

const UNKNOWN_MAIN_VIEW = 'vista esterna';
/** Foto successive alla prima con angolazione non ricavabile. */

const UNKNOWN_VIEW = 'altra vista';
const ALT_SEPARATOR = ' – ';

/**
 * Angolazioni riconosciute, dalla piu' specifica alla piu' generica:
 * l'ordine conta perche' "Anteriore Sinistra" deve vincere su "Anteriore".
 * Le stringhe che non descrivono un'inquadratura ("Vista Identificativa",
 * "Offerta auto {Modello}") non hanno una regola di proposito: devono cadere
 * sul fallback invece di far dichiarare un'angolazione inventata.
 */
const VIEW_RULES = [{
  pattern: /(anteriore|frontale|front)[\s-]*(sinistr\w*|sx)/i,
  view: 'vista tre quarti anteriore sinistra'
}, {
  pattern: /(anteriore|frontale|front)[\s-]*(destr\w*|dx)/i,
  view: 'vista tre quarti anteriore destra'
}, {
  pattern: /(posteriore|retro|rear)[\s-]*(sinistr\w*|sx)/i,
  view: 'vista tre quarti posteriore sinistra'
}, {
  pattern: /(posteriore|retro|rear)[\s-]*(destr\w*|dx)/i,
  view: 'vista tre quarti posteriore destra'
}, {
  pattern: /(laterale|fiancata|lato|side)[\s-]*(sinistr\w*|sx)/i,
  view: 'vista laterale sinistra'
}, {
  pattern: /(laterale|fiancata|lato|side)[\s-]*(destr\w*|dx)/i,
  view: 'vista laterale destra'
}, {
  pattern: /(obliqu\w*|tre quarti|3\/4)/i,
  view: 'vista tre quarti'
}, {
  pattern: /(interni|abitacolo|sedili)/i,
  view: 'vista interni'
}, {
  pattern: /(plancia|cruscotto|dashboard)/i,
  view: 'vista plancia e cruscotto'
}, {
  pattern: /(bagagliaio|baule|trunk)/i,
  view: 'vista bagagliaio'
}, {
  pattern: /(cerchi|cerchio|ruote|wheel)/i,
  view: 'dettaglio cerchi'
}, {
  pattern: /(anteriore|frontale|front)/i,
  view: 'vista frontale'
}, {
  pattern: /(posteriore|retro|rear)/i,
  view: 'vista posteriore'
}, {
  pattern: /(laterale|fiancata|side)/i,
  view: 'vista laterale'
}];

const squash = value => value.replace(/\s+/g, ' ').trim();
/**
 * "{Brand} {Modello} {Versione} {Anno}".
 * Le offerte di noleggio riguardano auto nuove e non espongono un anno di
 * immatricolazione, quindi si usa l'anno corrente, coerente con title e meta
 * description. Le offerte di vendita che valorizzano `year` usano il proprio.
 */


const getVehicleAltBase = function () {
  let {
    name,
    brand,
    model,
    version,
    year
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    formattedYear
  } = (0,_dateUtils__WEBPACK_IMPORTED_MODULE_1__/* .getFormattedMonthYear */ .P)();
  const vehicleName = name || `${brand || ''} ${model || ''}`;
  return squash([vehicleName, version, `${year || formattedYear}`].filter(Boolean).join(' '));
};
/**
 * Ricava l'angolazione dall'alt di origine, null se non e' riconoscibile.
 */

const getVehicleImageView = sourceAlt => {
  if (!sourceAlt) {
    return null;
  }

  const rule = VIEW_RULES.find(_ref => {
    let {
      pattern
    } = _ref;
    return pattern.test(sourceAlt);
  });
  return rule ? rule.view : null;
};
/**
 * Alt completo di una foto veicolo. `view` e' obbligatorio: va passata
 * l'angolazione reale dello scatto, non un default.
 */

const getVehicleImageAlt = (vehicle, view) => `${getVehicleAltBase(vehicle)}${ALT_SEPARATOR}${view}`;
/**
 * Alt per le card delle liste, dove l'angolazione spesso non e' nota: viene
 * aggiunta solo se ricavabile dall'alt di origine, altrimenti si resta sul
 * veicolo piu' il contesto (es. "noleggio a lungo termine").
 */

const getOfferCardAlt = (vehicle, context, sourceAlt) => {
  const base = squash(`${getVehicleAltBase(vehicle)} ${context}`);
  const view = getVehicleImageView(sourceAlt);
  return view ? `${base}${ALT_SEPARATOR}${view}` : base;
};
/**
 * Alt dei loghi di marca, unico punto in cui si compone la stringa "Logo ...".
 *
 * Va usata ovunque compaia un logo di marca - card marchi, titolo del PDP,
 * banner partnership, heading della privacy - cosi' la forma della stringa
 * resta una sola. Il `context` opzionale aggiunge la qualifica quando serve
 * distinguere il contesto (es. "Noleggio a Lungo Termine").
 */

const getBrandLogoAlt = (brand, context) => squash(`Logo ${brand || ''} ${context || ''}`);
/**
 * Dati anagrafici di un'offerta di vendita nella forma attesa dagli helper.
 * Il dettaglio espone brand/model/version sia sulla radice sia su `vehicle`,
 * che pero' e' opzionale e viene popolato solo se l'enrichment riesce.
 */

const getSellVehicleAltData = offer => {
  var _offer$vehicle, _offer$vehicle2, _offer$vehicle3, _offer$vehicle4;

  return {
    name: (_offer$vehicle = offer.vehicle) === null || _offer$vehicle === void 0 ? void 0 : _offer$vehicle.name,
    brand: ((_offer$vehicle2 = offer.vehicle) === null || _offer$vehicle2 === void 0 ? void 0 : _offer$vehicle2.brand) || offer.brand,
    model: ((_offer$vehicle3 = offer.vehicle) === null || _offer$vehicle3 === void 0 ? void 0 : _offer$vehicle3.model) || offer.model,
    version: ((_offer$vehicle4 = offer.vehicle) === null || _offer$vehicle4 === void 0 ? void 0 : _offer$vehicle4.version) || offer.version,
    year: offer.year
  };
};
/**
 * Riscrive gli alt di tutte le foto della gallery mantenendo l'angolazione
 * reale dello scatto. Eventuali collisioni vengono numerate per non avere due
 * alt identici nella stessa pagina.
 */

const getGalleryImagesAlt = (images, vehicle) => {
  if (!images || !images.length) {
    return [];
  }

  const usedAlts = [];
  return images.map((image, index) => {
    const view = getVehicleImageView(image.alt) || (index === 0 ? UNKNOWN_MAIN_VIEW : UNKNOWN_VIEW);
    const baseAlt = getVehicleImageAlt(vehicle, view);
    let alt = baseAlt;
    let occurrence = 1;

    while (usedAlts.indexOf(alt) !== -1) {
      occurrence += 1;
      alt = `${baseAlt} (${occurrence})`;
    }

    usedAlts.push(alt);
    return _objectSpread(_objectSpread({}, image), {}, {
      alt
    });
  });
};

/***/ })

}]);